import * as React from 'react';
import { SVGProps } from 'react';

const IconAxesRotateSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 3h1a1 1 0 0 0 1-1V1h1v1a2 2 0 0 1-2 2H1V3ZM11 3.5 8 1v2c-1.487 0-2.748.47-3.64 1.36C3.47 5.252 3 6.514 3 8H1l2.5 3L6 8H4c0-1.274.399-2.263 1.068-2.932C5.737 4.398 6.726 4 8 4v2l3-2.5Z" />
  </svg>
);
export default IconAxesRotateSizeXs;
